import React from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import '../config.js';
import { theme, getFormattedDate, getFormattedTime, downloadProforma } from '../services/helper.js';

function ProformaListItem(props) {

  return(
        <tr>
          <td>{props.info.proforma_id}</td>
          {props.type == 'all' && 
            <td width="20%">
              <Link to={"/client/"+props.info.client+"/proforma"} className={'btn btn-icon-split mr-2 btn-'+theme()}>
                <span className="icon text-white-50">
                  <i className="fas fa-link"></i>
                </span>
                <span className="text">{props.info.salutation} {props.info.first_name} {props.info.middle_name} {props.info.last_name}</span>
              </Link>
            </td>
          }
          <td width="40%">{props.info.description}</td>
          <td>{props.info.pax}</td>
          <td>{props.info.currency}</td>
          <td>{props.info.amount}</td>
          <td>{getFormattedDate(props.info.updation_date)}<br/>{getFormattedTime(props.info.updation_date)}</td>
          <td>
            <Link to={"/proforma/"+props.info.proforma_id+"/"+props.type} className={'btn btn-icon-split mr-2 btn-'+theme()}>
              <span className="icon text-white-50">
                <i className="fas fa-edit"></i>
              </span>
            </Link>
            <button className={'btn btn-icon-split btn-'+theme()} onClick={() => downloadProforma(axios, props.info.proforma_id)}>
              <span className="icon text-white-50">
                <i className="fas fa-download"></i>
              </span>
            </button>
          </td>
        </tr>
  )
}

export default ProformaListItem;